import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart, Sparkles, Users, Moon } from 'lucide-react';
import './About.css';

export const About = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const principles = [
    {
      icon: <Heart size={28} />,
      title: 'Embodied Healing',
      description: 'Coming home to the body as a temple of truth'
    },
    {
      icon: <Sparkles size={28} />,
      title: 'Emotional Liberation',
      description: 'Releasing old pain, shame, and self-abandonment'
    },
    {
      icon: <Users size={28} />,
      title: 'Sacred Union',
      description: 'Integration of inner masculine & feminine'
    },
    {
      icon: <Moon size={28} />,
      title: 'Womb & Root Healing',
      description: 'Rewriting stories stored in the belly'
    }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="heading-hero">About Tshidi</h1>
          <p className="body-large" style={{ maxWidth: '700px', margin: '1.5rem auto 0' }}>
            A journey into healing, embodiment, and the sacred art of living soulfully
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="about-content-section">
        <div className="container">
          <div className="about-grid">
            <div className="about-image-container" onClick={() => setSelectedImage('https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/xc6cij32_image16.jpeg')} style={{ cursor: 'pointer' }}>
              <img 
                src="https://customer-assets.emergentagent.com/job_33648ce9-55a6-4073-8c73-14e57d771a90/artifacts/gjjj1138_WhatsApp%20Image%202026-04-16%20at%2009.32.07.jpeg" 
                alt="Tshidi Tsimile"
                className="about-main-image"
              />
            </div>
            <div className="about-text-content">
              <h2 className="heading-1" style={{ marginBottom: '1.5rem' }}>My Mission</h2>
              <p className="body-medium" style={{ marginBottom: '1.5rem' }}>
                Tshidi Tsimile Company exists to guide women and men back to the pleasure of being alive — the pleasure of feeling, knowing, and trusting themselves.
              </p>
              <p className="body-medium" style={{ marginBottom: '1.5rem' }}>
                Inspired by The Ministry of Pleasure, my work anchors the truth that pleasure is not indulgence — it is medicine, alignment, and the deepest form of prayer.
              </p>
              <p className="body-medium">
                My teachings weave psychology, spirituality, ancestral wisdom, and sensual embodiment into practical healing pathways that return people to wholeness, confidence, and inner radiance.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Principles */}
      <section className="principles-section">
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '3rem' }}>What I Help You Reconnect With</h2>
          <div className="principles-grid">
            {principles.map((principle) => (
              <div key={principle.title} className="principle-card">
                <div className="principle-icon">{principle.icon}</div>
                <h3 className="heading-3" style={{ marginBottom: '0.5rem' }}>{principle.title}</h3>
                <p className="body-small">{principle.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Areas */}
      <section className="areas-section">
        <div className="container">
          <div className="areas-content">
            <h2 className="heading-1" style={{ marginBottom: '1.5rem' }}>Areas of Practice</h2>
            <div className="areas-list">
              <div className="area-item">
                <div className="area-dot"></div>
                <p className="body-medium">Depth Psychology & Shadow Work</p>
              </div>
              <div className="area-item">
                <div className="area-dot"></div>
                <p className="body-medium">Spiritual Awakening & Soul Work</p>
              </div>
              <div className="area-item">
                <div className="area-dot"></div>
                <p className="body-medium">Womb Healing & Feminine Embodiment</p>
              </div>
              <div className="area-item">
                <div className="area-dot"></div>
                <p className="body-medium">Sacred Union & Relationship Development</p>
              </div>
              <div className="area-item">
                <div className="area-dot"></div>
                <p className="body-medium">Corporate Emotional Wellness Programs</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="philosophy-section">
        <div className="container">
          <div className="philosophy-content">
            <h2 className="heading-1" style={{ marginBottom: '2rem' }}>My Message</h2>
            <blockquote className="philosophy-quote">
              <p className="body-large">
                You are meant to live a life that feels good — in your body, your relationships, your emotions, and your spirit.
              </p>
              <p className="body-large">
                Healing is not only about fixing — it is about remembering.
              </p>
              <p className="body-large">
                Pleasure is not a reward — it is a birthright.
              </p>
            </blockquote>
          </div>
        </div>
      </section>

      {/* Media Appearances & Clients */}
      <section className="media-section">
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '3rem' }}>Media Appearances & Clients</h2>
          
          {/* First row - slides left to right */}
          <div className="media-scroll-container">
            <div className="media-scroll-row scroll-left">
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/8zjpfu36_702%20logo.png" alt="702" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/5dyyyg0w_Amabishop%20Logo.jpg" alt="Amabishop" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/ocn5p3qs_E%20TV%20Logo.png" alt="E TV" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/bq8i6kt7_Kaya%20959%20Logo.jpg" alt="Kaya 959" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/0y6pgqr5_Moja%20Love%20Logo.JPG" alt="Moja Love" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/a4z9lqhg_Motsweding%20Fm%20Logo.jpg" alt="Motsweding FM" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/wmbjn7z1_Move%20Logo.jpg" alt="Move" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/nm74q1bt_Moya%20Podcast%20Logo.png" alt="Moya Podcast" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/bkoewplu_Pulpit%20Radio%20Logo.jpg" alt="Pulpit Radio" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/lc23tt14_Kasi%20FM%20Logo.jpg" alt="Kasi FM" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/o0ff3b3o_Radio%202000%20Logo.jpg" alt="Radio 2000" />
              </div>
              {/* Duplicate for seamless loop */}
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/8zjpfu36_702%20logo.png" alt="702" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/5dyyyg0w_Amabishop%20Logo.jpg" alt="Amabishop" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/ocn5p3qs_E%20TV%20Logo.png" alt="E TV" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/bq8i6kt7_Kaya%20959%20Logo.jpg" alt="Kaya 959" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/0y6pgqr5_Moja%20Love%20Logo.JPG" alt="Moja Love" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/a4z9lqhg_Motsweding%20Fm%20Logo.jpg" alt="Motsweding FM" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/wmbjn7z1_Move%20Logo.jpg" alt="Move" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/nm74q1bt_Moya%20Podcast%20Logo.png" alt="Moya Podcast" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/bkoewplu_Pulpit%20Radio%20Logo.jpg" alt="Pulpit Radio" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/lc23tt14_Kasi%20FM%20Logo.jpg" alt="Kasi FM" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/o0ff3b3o_Radio%202000%20Logo.jpg" alt="Radio 2000" />
              </div>
            </div>
          </div>

          {/* Second row - slides right to left */}
          <div className="media-scroll-container">
            <div className="media-scroll-row scroll-right">
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/d7cquvsx_Carte%20Blanche%20Logo.jpg" alt="Carte Blanche" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/k0w2rvqk_Drum%20Logo.JPG" alt="Drum" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/gpipwpl5_Lesedi%20FM.jpg" alt="Lesedi FM" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/csiq1wvo_Showmax%20Logo.jpg" alt="Showmax" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/ah6p5pv0_Sowetan%20LIVE%20Logo.jpg" alt="Sowetan LIVE" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/3rjiuk0f_30%20Pearls%20of%20Wisdom%20Logo.jpg" alt="30 Pearls of Wisdom" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/ebropjh8_Credit%20Guarantee%20logo.png" alt="Credit Guarantee" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/0lil5o7b_Dr%20Gauri%20Lowe%20Logo.jpg" alt="Dr Gauri Lowe" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/om3k5v6h_Micdrop%20Logo.png" alt="Micdrop" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/o2j7ntkq_The%20doj%20%26%20cd%20logo.png" alt="The DOJ & CD" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/h2shjshp_938%20Fm%20Logo.jpeg" alt="938 FM" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/2x5n8nan_Kingdom%20Chaos%20podcast.jpg" alt="Kingdom Chaos Podcast" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/rwhtgvr8_Massive%20Metro%20Logo.jpg" alt="Massive Metro" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/jt88ngvi_Thobela%20FM%20Logo.png" alt="Thobela FM" />
              </div>
              {/* Duplicate for seamless loop */}
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/d7cquvsx_Carte%20Blanche%20Logo.jpg" alt="Carte Blanche" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/k0w2rvqk_Drum%20Logo.JPG" alt="Drum" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/gpipwpl5_Lesedi%20FM.jpg" alt="Lesedi FM" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/csiq1wvo_Showmax%20Logo.jpg" alt="Showmax" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/ah6p5pv0_Sowetan%20LIVE%20Logo.jpg" alt="Sowetan LIVE" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/3rjiuk0f_30%20Pearls%20of%20Wisdom%20Logo.jpg" alt="30 Pearls of Wisdom" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/ebropjh8_Credit%20Guarantee%20logo.png" alt="Credit Guarantee" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/0lil5o7b_Dr%20Gauri%20Lowe%20Logo.jpg" alt="Dr Gauri Lowe" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/om3k5v6h_Micdrop%20Logo.png" alt="Micdrop" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/o2j7ntkq_The%20doj%20%26%20cd%20logo.png" alt="The DOJ & CD" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/h2shjshp_938%20Fm%20Logo.jpeg" alt="938 FM" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/2x5n8nan_Kingdom%20Chaos%20podcast.jpg" alt="Kingdom Chaos Podcast" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/rwhtgvr8_Massive%20Metro%20Logo.jpg" alt="Massive Metro" />
              </div>
              <div className="media-logo-item">
                <img src="https://customer-assets.emergentagent.com/job_pleasure-medicine/artifacts/jt88ngvi_Thobela%20FM%20Logo.png" alt="Thobela FM" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta-section">
        <div className="container">
          <div className="about-cta-content">
            <h2 className="heading-1" style={{ marginBottom: '1.5rem' }}>Begin Your Healing Journey</h2>
            <p className="body-large" style={{ marginBottom: '2rem' }}>
              Discover how we can work together to help you reconnect with your authentic self.
            </p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/contact" className="btn-primary">Contact Us</Link>
              <Link to="/services" className="btn-secondary">Explore Services</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="image-modal"
          onClick={() => setSelectedImage(null)}
        >
          <div className="image-modal-content">
            <button 
              className="image-modal-close"
              onClick={() => setSelectedImage(null)}
              aria-label="Close"
            >
              ×
            </button>
            <img src={selectedImage} alt="Full view" />
          </div>
        </div>
      )}
    </div>
  );
};